var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.bus, "max-width": "700px", height: "670px" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "" },
                  on: {
                    click: function($event) {
                      return _vm.filtrar(close)
                    }
                  }
                },
                [_vm._v(" Filtrar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "30px 34px 50px" } },
        [
          _c("Title", {
            attrs: {
              title: "Filtre sua pesquisa",
              subtitle: "Use os filtros para melhorar sua pesquisa"
            }
          }),
          _c(
            "div",
            {
              staticStyle: {
                height: "350px",
                overflow: "auto",
                "padding-right": "5px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "v-application" },
                [
                  _c(
                    "v-expansion-panels",
                    {
                      attrs: { multiple: "" },
                      model: {
                        value: _vm.panels,
                        callback: function($$v) {
                          _vm.panels = $$v
                        },
                        expression: "panels"
                      }
                    },
                    [
                      _c(
                        "v-expansion-panel",
                        {
                          staticStyle: { "background-color": "var(--gray-2)" }
                        },
                        [
                          _c(
                            "v-expansion-panel-header",
                            {
                              staticClass: "v-application py-0",
                              scopedSlots: _vm._u([
                                {
                                  key: "actions",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-plus")]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _c("h2", { staticClass: "panel-title" }, [
                                _vm._v("Serviços")
                              ])
                            ]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            { staticClass: "v-application--is-ltr" },
                            [
                              _c(
                                "div",
                                { staticClass: "row pt-0 align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-2 text-right text-sm" },
                                    [_vm._v(" Nome ")]
                                  ),
                                  _c("div", { staticClass: "col-5" }, [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "input",
                                          attrs: {
                                            placeholder: "Nome do serviço",
                                            "background-color":
                                              _vm.Color["light_mode"]["gray-1"],
                                            solo: "",
                                            flat: ""
                                          },
                                          model: {
                                            value:
                                              _vm.filtro_servicos.nome_servico,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro_servicos,
                                                "nome_servico",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filtro_servicos.nome_servico"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "col-5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "input-group input-select"
                                      },
                                      [
                                        _c("v-select", {
                                          staticClass: "input bg-gray-1",
                                          attrs: {
                                            placeholder: "Taxa (% ou R$)",
                                            "background-color":
                                              _vm.Color["light_mode"]["gray-1"],
                                            solo: "",
                                            flat: "",
                                            "append-icon": "mdi-chevron-down",
                                            items: ["Taxa %", "Taxa R$"]
                                          },
                                          model: {
                                            value:
                                              _vm.filtro_servicos.tipo_taxa,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro_servicos,
                                                "tipo_taxa",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filtro_servicos.tipo_taxa"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "row pt-0 align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-2 text-right text-sm" },
                                    [_vm._v(" Valor total ")]
                                  ),
                                  _c("div", { staticClass: "col-5" }, [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "input bg-gray-1",
                                          attrs: {
                                            placeholder: "Menor",
                                            "background-color":
                                              _vm.Color["light_mode"]["gray-1"],
                                            solo: "",
                                            flat: ""
                                          },
                                          model: {
                                            value:
                                              _vm.filtro_servicos
                                                .valor_total_menor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro_servicos,
                                                "valor_total_menor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filtro_servicos.valor_total_menor"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "col-5" }, [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "input bg-gray-1",
                                          attrs: {
                                            placeholder: "Maior",
                                            "background-color":
                                              _vm.Color["light_mode"]["gray-1"],
                                            solo: "",
                                            flat: ""
                                          },
                                          model: {
                                            value:
                                              _vm.filtro_servicos
                                                .valor_total_maior,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro_servicos,
                                                "valor_total_maior",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filtro_servicos.valor_total_maior"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "row pt-0 align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-2 text-right text-sm" },
                                    [_vm._v(" Quantidade de clientes ")]
                                  ),
                                  _c("div", { staticClass: "col-5" }, [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "input bg-gray-1",
                                          attrs: {
                                            placeholder: "Menor",
                                            "background-color":
                                              _vm.Color["light_mode"]["gray-1"],
                                            solo: "",
                                            flat: ""
                                          },
                                          model: {
                                            value:
                                              _vm.filtro_servicos
                                                .qtd_clientes_menor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro_servicos,
                                                "qtd_clientes_menor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filtro_servicos.qtd_clientes_menor"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "col-5" }, [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "input bg-gray-1",
                                          attrs: {
                                            placeholder: "Maior",
                                            "background-color":
                                              _vm.Color["light_mode"]["gray-1"],
                                            solo: "",
                                            flat: ""
                                          },
                                          model: {
                                            value:
                                              _vm.filtro_servicos
                                                .qtd_clientes_maior,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro_servicos,
                                                "qtd_clientes_maior",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filtro_servicos.qtd_clientes_maior"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        {
                          staticStyle: { "background-color": "var(--gray-2)" }
                        },
                        [
                          _c(
                            "v-expansion-panel-header",
                            {
                              staticClass: "v-application py-0",
                              scopedSlots: _vm._u([
                                {
                                  key: "actions",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-plus")]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _c("h2", { staticClass: "panel-title" }, [
                                _vm._v("Clientes")
                              ])
                            ]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            { staticClass: "v-application--is-ltr" },
                            [
                              _c(
                                "div",
                                { staticClass: "row pt-0 align-items-center" },
                                [
                                  _c("div", { staticClass: "col-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "input bg-gray-1",
                                          attrs: {
                                            placeholder: "Nome",
                                            "background-color":
                                              _vm.Color["light_mode"]["gray-1"],
                                            solo: "",
                                            flat: ""
                                          },
                                          model: {
                                            value: _vm.filtro_clientes.nome,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro_clientes,
                                                "nome",
                                                $$v
                                              )
                                            },
                                            expression: "filtro_clientes.nome"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", { staticClass: "col-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "input bg-gray-1",
                                          attrs: {
                                            placeholder: "P/L",
                                            "background-color":
                                              _vm.Color["light_mode"]["gray-1"],
                                            solo: "",
                                            flat: ""
                                          },
                                          model: {
                                            value: _vm.filtro_clientes.pl,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro_clientes,
                                                "pl",
                                                $$v
                                              )
                                            },
                                            expression: "filtro_clientes.pl"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }